import { render } from "./packageManagementX.vue?vue&type=template&id=5a02ad33&scoped=true"
import script from "./packageManagementX.vue?vue&type=script&lang=js"
export * from "./packageManagementX.vue?vue&type=script&lang=js"

import "./packageManagementX.vue?vue&type=style&index=0&id=5a02ad33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a02ad33"

export default script